import React from 'react';
import { convertDays, convertNumber } from 'utils/date';

export const TitleComment = ({
  className,
  currentAmount,
  targetAmount,
  targetStartDate,
  targetEndDate,
}: {
  className: string;
  currentAmount: number;
  targetAmount: number;
  targetStartDate: Date;
  targetEndDate: Date;
}): React.ReactElement => {
  const isGoalAchievement = targetAmount <= currentAmount;
  const achievementRate = (currentAmount / targetAmount) * 100;
  const nowDate = new Date();

  const comment = (() => {
    // 目標達成時
    if (isGoalAchievement) {
      return '目標達成！';
    }

    // クライアント日時がずれていた場合は開始日よりも前のデータを取得してしまう可能性があるので念のために対応しておく
    if (convertNumber(nowDate) < convertNumber(targetStartDate)) {
      return '無理なく続けましょう';
    }
    // 終了後
    if (convertNumber(targetEndDate) < convertNumber(nowDate)) {
      return 'お疲れさまでした！';
    }
    // 以降同年同月で目標未達成時の処理
    // 達成率20%未満共通
    if (achievementRate < 20) {
      return '無理なく続けましょう';
    }
    // 残日数比率
    // 開始から現在までの期間日数 / 対象期間日数 * 100
    const daysLeftRate =
      (convertDays(targetStartDate, nowDate) /
        convertDays(targetStartDate, targetEndDate)) *
      100;

    // 達成率20%～40%未満
    if (achievementRate < 40) {
      if (daysLeftRate < 30) {
        return '無理なく続けましょう';
      }
      if (daysLeftRate < 70) {
        return 'その調子です';
      }
      return 'いいペースです！';
    }
    // 達成率40%～70%未満
    if (achievementRate < 70) {
      if (daysLeftRate < 30) {
        return 'その調子です';
      }
      if (daysLeftRate < 70) {
        return 'いいペースです！';
      }
      return 'がんばっていますね！';
    }
    // 達成率70%～90%未満
    if (achievementRate < 90) {
      if (daysLeftRate < 30) {
        return 'いいペースです！';
      }
      if (daysLeftRate < 70) {
        return 'がんばっていますね！';
      }
      return '好調ですね！';
    }
    // 達成率90%～100%未満
    if (daysLeftRate < 30) {
      return 'もう少しで達成！';
    }
    if (daysLeftRate < 70) {
      return '好調ですね！';
    }
    return 'かなり早いペース';
  })();

  return (
    <div
      className={`flex flex-row items-center text-base font-bold ${
        className ? className : ''
      }`}>
      {comment}
    </div>
  );
};
